//=====================================================
//　G008：ログイン画面
//=====================================================
import { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { AxiosResponse } from 'axios';
import { FormBox } from '../../common/FormBox';
import { ContentsBox } from '../../common/ContentsBox';
import { ContentsTitle } from '../../common/ContentsTitle';
import { BtnSubmit } from '../../common/BtnSubmit';
import { BtnReturn } from '../../common/BtnReturn';
import { TxtLoginId } from '../../common/TxtLoginId';
import { TxtLoginPassword } from '../../common/TxtLoginPassword';
import { MsgBoxErr } from '../../common/MsgBoxErr';
import { CtxAuth,CtxClinicInfo,CtxPatientInfo,CtxSystemErr } from '../../utils/Contexts';
import { ConstMsg } from "../../utils/ConstMsg";
import { LoadingBox } from "../../common/LoadingBox";

export function G008(){

    const [errmess, setErrmess] = useState('');
    const [loadingDone, setLoadingDone] = useState(true);

    const cserr = useContext(CtxSystemErr);
    const cci = useContext(CtxClinicInfo);
    const cpi = useContext(CtxPatientInfo);
    const cua = useContext(CtxAuth);
    const history = useHistory();
    const uf = useForm({reValidateMode: 'onSubmit'});
    
    //入力項目名
    const FORM_NAME_LOGINID = 'input-loginid';
    const FORM_NAME_LOGINPASSWORD = 'input-login-password';
 
    //まずログアウト
    useEffect(function(){
        //　タイトル追加処理
        if(cci.data.name){
            document.title = cci.data.name + " | Web予約 - ログイン画面";
        }else{
            document.title = process.env.REACT_APP_DEFAULT_CLININC_NAME + " | Web予約 - ログイン画面";
        }

        cua.logout(cpi.clear()); 
        // 指定すると無限ループするので、cua,cpiは第2引数から除外する
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //ログインボタンクリック処理
    //バリデーション通過時処理
    function FormSubmit(){
        setLoadingDone(false);
        setErrmess('');
        cua.login(cci.data.id, uf.getValues(FORM_NAME_LOGINID), uf.getValues(FORM_NAME_LOGINPASSWORD), 
            function(res:AxiosResponse<any>){
                if( res.status === 200 ){
                    //正常ケース
                    let errMess = cpi.getData(cci.data.id, uf.getValues(FORM_NAME_LOGINID));
                    if(errMess){
                        cserr.setErrmess(errMess);
                    }else{
                        history.push('/mypage') ;
                    }
                }else{
                    if( res.status === 400 || res.status === 401 ){
                        setErrmess(res?.data.message);
                    }else if( res.status === 403 || res.status >= 500 ){
                        cserr.setErrmess(res?.data.message);
                    }else{
                        if (res?.data) {
                            cserr.setErrmess(res?.data.message);
                        } else {
                            cserr.setErrmess(ConstMsg.EG9990001);
                        }
                    }
                }
                setLoadingDone(true);
            }
        );
    }

    //初期値表示なし
    return (
        <>
        <ContentsBox>
            <ContentsTitle title='マイページログイン' />
            {errmess && <MsgBoxErr text={errmess} />}
            <LoadingBox overlay={true} loadingDone={loadingDone}>
                <FormBox useForm={uf} successFunc={FormSubmit} className='login-box'>
                    <TxtLoginId name={FORM_NAME_LOGINID} />
                    <TxtLoginPassword name={FORM_NAME_LOGINPASSWORD} />
                    <BtnSubmit title='ログイン'  />
                </FormBox>
            </LoadingBox>
        </ContentsBox>
        <BtnReturn onClick={function(){history.push('/')}} />
        </>
    );

}